'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GlobalHeader = require('../v3/GlobalHeader');

var _GlobalHeader2 = _interopRequireDefault(_GlobalHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlobalHeader = function (_GlobalHeaderV) {
  _inherits(GlobalHeader, _GlobalHeaderV);

  function GlobalHeader(props) {
    _classCallCheck(this, GlobalHeader);

    var _this = _possibleConstructorReturn(this, (GlobalHeader.__proto__ || Object.getPrototypeOf(GlobalHeader)).call(this, props));

    _this.handleOrientationChange = function () {};

    _this.processFixedStyleState = function () {};

    _this.processStickyState = function () {};

    _this.state.isHeaderFixed = false;
    return _this;
  }

  return GlobalHeader;
}(_GlobalHeader2.default);

exports.default = GlobalHeader;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/header/jsx/v4/GlobalHeader.js
// module id = 1102
// module chunks = 4